import request from "src/utils/request";
import useApi from "src/utils/api/use-api";
import { sleep } from "src/utils/api/mock-utils";
import { useAuth } from "../../components/providers/auth-context";

const useIntegrationsApi = () => {
    const { isDemo } = useAuth();
    const getMockData = async () => {
        await sleep();
        return {
            integrations: [
                { name: "slack", connected: true },
                { name: "gitlab", connected: false },
                { name: "gitlabSelfManaged", connected: false },
                { name: "github", connected: true },
                { name: "google", connected: true },
                { name: "jira", connected: true },
                { name: "microsoft", connected: false },
                { name: "notion", connected: false },
            ],
        };
    };
    if (process.env.MOCK_INTEGRATIONS === "true") return useApi(() => getMockData());
    if (isDemo)
        return useApi(() => ({
            integrations: [
                {
                    name: "slack",
                    connected: true,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "gitlab",
                    connected: false,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "gitlabSelfManaged",
                    connected: false,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "github",
                    connected: true,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "google",
                    connected: true,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "jira",
                    connected: true,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "microsoft",
                    connected: false,
                    status: "complete",
                    invalid: false,
                },
                {
                    name: "notion",
                    connected: false,
                    status: "complete",
                    invalid: false,
                },
            ],
        }));
    return useApi(() => request("/api/users/me/integrations"));
};

export default useIntegrationsApi;
